import React, { Component} from 'react'

class AddButton extends Component {
	render() {
		const { onClick } = this.props

		return (
			<div className="wrap_add ">
				<label className="lab_btn lab_add">
					<span className="ico_blog ico_add" />
					메뉴 추가
					<input type="button" className="btn_g" value="메뉴 추가" onClick={onClick} />
				</label>
			</div>
		)
	}
}

export default AddButton
